import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_4 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_5 = { class: "d-block text-body-tertiary fw-normal" }
const _hoisted_6 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "d-flex justify-content-between" }
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_19 = {
  key: 0,
  class: "ph ph-code"
}
const _hoisted_20 = {
  key: 1,
  class: "mb-0 quill-editor"
}
const _hoisted_21 = {
  key: 2,
  class: "form-messages mt-2 px-1"
}
const _hoisted_22 = {
  key: 0,
  class: "col-12"
}
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "d-flex justify-content-between" }
const _hoisted_25 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_26 = {
  key: 0,
  class: "ph ph-code"
}
const _hoisted_27 = {
  key: 1,
  class: "mb-0 quill-editor"
}
const _hoisted_28 = {
  key: 2,
  class: "form-messages mt-2 px-1"
}
const _hoisted_29 = {
  key: 1,
  class: "col-12"
}
const _hoisted_30 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_31 = { class: "d-flex justify-content-between" }
const _hoisted_32 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_33 = {
  key: 0,
  class: "ph ph-code"
}
const _hoisted_34 = {
  key: 1,
  class: "mb-0 quill-editor"
}
const _hoisted_35 = {
  key: 2,
  class: "form-messages mt-2 px-1"
}
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_38 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_39 = ["required", "disabled"]
const _hoisted_40 = ["value"]
const _hoisted_41 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_43 = { class: "col-6 col-sm-4 col-md-3" }
const _hoisted_44 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_45 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_46 = ["required"]
const _hoisted_47 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_48 = { class: "col-sm-8 col-md-6" }
const _hoisted_49 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_50 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_51 = ["required"]
const _hoisted_52 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_54 = { class: "col-6 col-sm-4 col-md-3" }
const _hoisted_55 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_56 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_57 = ["required"]
const _hoisted_58 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_59 = { class: "col-sm-8 col-md-6" }
const _hoisted_60 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_61 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_62 = ["required"]
const _hoisted_63 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_65 = { class: "col-6 col-sm-4 col-md-3" }
const _hoisted_66 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_67 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_68 = ["required"]
const _hoisted_69 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_70 = { class: "col-12" }
const _hoisted_71 = { class: "form-check form-group form-switch mb-15 mb-sm-20 mb-md-25" }
const _hoisted_72 = {
  class: "form-check-label fw-medium position-relative top-1",
  for: "required"
}
const _hoisted_73 = { class: "col-12" }
const _hoisted_74 = { class: "form-check form-group form-switch mb-15 mb-sm-20 mb-md-25" }
const _hoisted_75 = {
  class: "form-check-label fw-medium position-relative top-1",
  for: "include_na_option"
}
const _hoisted_76 = { class: "col-md-6" }
const _hoisted_77 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_78 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_79 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_81 = { class: "col-12" }
const _hoisted_82 = { class: "form-check form-group form-switch mb-15 mb-sm-20 mb-md-25" }
const _hoisted_83 = {
  class: "form-check-label fw-medium position-relative top-1",
  for: "display_in_chart"
}
const _hoisted_84 = { class: "col-md-6" }
const _hoisted_85 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_86 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_87 = ["required"]
const _hoisted_88 = ["value"]
const _hoisted_89 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!

  return (_ctx.local_step !== undefined && _ctx.lang != undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" KEY "),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.$t('form.key.label')) + "* ", 1 /* TEXT */),
              _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.$t('feature.surveys.$steps.key_recommendations')), 1 /* TEXT */)
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.local_step.key) = $event)),
              class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.key }]]),
              required: ""
            }, null, 2 /* CLASS */), [
              [_vModelText, _ctx.local_step.key]
            ]),
            _createCommentVNode(" ERRORS "),
            (_ctx.errors?.key ?? false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.key, (error) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: error,
                      class: "small text-danger lh-1 m-0 mt-1"
                    }, _toDisplayString(error), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _hoisted_7,
        _createCommentVNode(" TYPE "),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('feature.surveys.$steps.type')) + "* ", 1 /* TEXT */),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.text }]]),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.local_step.type) = $event)),
                required: "",
                disabled: _ctx.update
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typologies, (key) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: key,
                    key: key
                  }, _toDisplayString(_ctx.$t(`feature.surveys.$steps.$type.${key}`)), 9 /* TEXT, PROPS */, _hoisted_12))
                }), 128 /* KEYED_FRAGMENT */))
              ], 10 /* CLASS, PROPS */, _hoisted_11), [
                [_vModelSelect, _ctx.local_step.type]
              ]),
              _createCommentVNode(" ERRORS "),
              (_ctx.errors?.type ?? false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.type, (error) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: error,
                        class: "small text-danger lh-1 m-0 mt-1"
                      }, _toDisplayString(error), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _hoisted_14,
        _createCommentVNode(" TITLE "),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('form.title.label')) + "* ", 1 /* TEXT */),
              _createElementVNode("div", {
                class: "icon-link transition mb-10 cursor-pointer text-uppercase",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleRawEdit && _ctx.toggleRawEdit(...args)))
              }, [
                (!_ctx.raw_edit)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                  : _createCommentVNode("v-if", true),
                _createTextVNode(" " + _toDisplayString(_ctx.raw_edit ? _ctx.$t('feature.contents.$blocks.editor') : _ctx.$t('feature.contents.$blocks.raw')), 1 /* TEXT */)
              ])
            ]),
            _createCommentVNode(" RAW EDIT "),
            (_ctx.raw_edit)
              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 0,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.local_step.title![_ctx.lang]) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.title }]]),
                  rows: "8",
                  required: ""
                }, null, 2 /* CLASS */)), [
                  [_vModelText, _ctx.local_step.title![_ctx.lang]]
                ])
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(), _createBlock(_component_QuillEditor, {
                    theme: "snow",
                    toolbar: _ctx.toolbar,
                    content: _ctx.local_step.title![_ctx.lang],
                    "onUpdate:content": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.local_step.title![_ctx.lang]) = $event)),
                    contentType: "html",
                    key: `${_ctx.local_step.id}-title-${_ctx.lang}-${_ctx.changes}`
                  }, null, 8 /* PROPS */, ["toolbar", "content"]))
                ])),
            _createCommentVNode(" ERRORS "),
            (_ctx.errors?.title ?? false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.title, (error) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: error,
                      class: "small text-danger lh-1 m-0 mt-1"
                    }, _toDisplayString(error), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createCommentVNode(" TEXT "),
        (_ctx.local_step.title !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('form.subtitle.label')), 1 /* TEXT */),
                  _createElementVNode("div", {
                    class: "icon-link transition mb-10 cursor-pointer text-uppercase",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleRawEdit && _ctx.toggleRawEdit(...args)))
                  }, [
                    (!_ctx.raw_edit)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_26))
                      : _createCommentVNode("v-if", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.raw_edit ? _ctx.$t('feature.contents.$blocks.editor') : _ctx.$t('feature.contents.$blocks.raw')), 1 /* TEXT */)
                  ])
                ]),
                _createCommentVNode(" RAW EDIT "),
                (_ctx.raw_edit)
                  ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                      key: 0,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.local_step.text![_ctx.lang]) = $event)),
                      class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.text }]]),
                      rows: "8",
                      required: ""
                    }, null, 2 /* CLASS */)), [
                      [_vModelText, _ctx.local_step.text![_ctx.lang]]
                    ])
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      (_openBlock(), _createBlock(_component_QuillEditor, {
                        theme: "snow",
                        content: _ctx.local_step.text![_ctx.lang],
                        "onUpdate:content": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.local_step.text![_ctx.lang]) = $event)),
                        contentType: "html",
                        key: `${_ctx.local_step.id}-text-${_ctx.lang}-${_ctx.changes}`
                      }, null, 8 /* PROPS */, ["content"]))
                    ])),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.text ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.text, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" FOOTER "),
        (_ctx.local_step.body !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('form.body.label')), 1 /* TEXT */),
                  _createElementVNode("div", {
                    class: "icon-link transition mb-10 cursor-pointer text-uppercase",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleRawEdit && _ctx.toggleRawEdit(...args)))
                  }, [
                    (!_ctx.raw_edit)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                      : _createCommentVNode("v-if", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.raw_edit ? _ctx.$t('feature.contents.$blocks.editor') : _ctx.$t('feature.contents.$blocks.raw')), 1 /* TEXT */)
                  ])
                ]),
                _createCommentVNode(" RAW EDIT "),
                (_ctx.raw_edit)
                  ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                      key: 0,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.local_step.body![_ctx.lang]) = $event)),
                      class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.body }]]),
                      rows: "8",
                      required: ""
                    }, null, 2 /* CLASS */)), [
                      [_vModelText, _ctx.local_step.body![_ctx.lang]]
                    ])
                  : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      (_openBlock(), _createBlock(_component_QuillEditor, {
                        theme: "snow",
                        content: _ctx.local_step.body![_ctx.lang],
                        "onUpdate:content": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.local_step.body![_ctx.lang]) = $event)),
                        contentType: "html",
                        key: `${_ctx.local_step.id}-body-${_ctx.lang}-${_ctx.changes}`
                      }, null, 8 /* PROPS */, ["content"]))
                    ])),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.body ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.body, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.local_step.type === 'V')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createCommentVNode(" VALUE REPRESANTION TYPE "),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('feature.surveys.value_representation_type')) + "* ", 1 /* TEXT */),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("select", {
                      class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.value_representation_type }]]),
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.local_step.value_representation_type) = $event)),
                      required: _ctx.local_step.type === 'V',
                      disabled: _ctx.update
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value_representation_types, (key) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: key,
                          key: key
                        }, _toDisplayString(_ctx.$t(`feature.surveys.$value_representation_type.${key}`)), 9 /* TEXT, PROPS */, _hoisted_40))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 10 /* CLASS, PROPS */, _hoisted_39), [
                      [_vModelSelect, _ctx.local_step.value_representation_type]
                    ]),
                    _createCommentVNode(" ERRORS "),
                    (_ctx.errors?.value_representation_type ?? false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.value_representation_type, (error) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: error,
                              class: "small text-danger lh-1 m-0 mt-1"
                            }, _toDisplayString(error), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ]),
              _hoisted_42,
              _createCommentVNode(" MIN "),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('feature.surveys.min_value')) + "* ", 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.local_step.min_value) = $event)),
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.min_value }]]),
                    required: _ctx.local_step.type === 'V',
                    type: "number"
                  }, null, 10 /* CLASS, PROPS */, _hoisted_46), [
                    [_vModelText, _ctx.local_step.min_value]
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.min_value ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.min_value, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createCommentVNode(" MIN LABEL"),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t('feature.surveys.min_label')) + "* ", 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.local_step.min_label) = $event)),
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.min_label }]]),
                    required: _ctx.local_step.type === 'V'
                  }, null, 10 /* CLASS, PROPS */, _hoisted_51), [
                    [_vModelText, _ctx.local_step.min_label]
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.min_label ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.min_label, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _hoisted_53,
              _createCommentVNode(" MAX "),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t('feature.surveys.max_value')) + "* ", 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.local_step.max_value) = $event)),
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.max_value }]]),
                    required: _ctx.local_step.type === 'V',
                    type: "number"
                  }, null, 10 /* CLASS, PROPS */, _hoisted_57), [
                    [_vModelText, _ctx.local_step.max_value]
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.max_value ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.max_value, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createCommentVNode(" MAX LABEL "),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('feature.surveys.max_label')) + "* ", 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.local_step.max_label) = $event)),
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.max_label }]]),
                    required: _ctx.local_step.type === 'V'
                  }, null, 10 /* CLASS, PROPS */, _hoisted_62), [
                    [_vModelText, _ctx.local_step.max_label]
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.max_label ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.max_label, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _hoisted_64,
              _createCommentVNode(" STEP INCREMENT "),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t('feature.surveys.step_increment')) + "* ", 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.local_step.step_increment) = $event)),
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.step_increment }]]),
                    required: _ctx.local_step.type === 'V',
                    type: "number"
                  }, null, 10 /* CLASS, PROPS */, _hoisted_68), [
                    [_vModelText, _ctx.local_step.step_increment]
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.step_increment ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.step_increment, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" REQUIRED "),
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input shadow-none me-8",
              type: "checkbox",
              role: "switch",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.local_step.required) = $event)),
              id: "required",
              "true-value": 1,
              "false-value": 0
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, _ctx.local_step.required]
            ]),
            _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.$t('feature.surveys.required')), 1 /* TEXT */)
          ])
        ]),
        _createCommentVNode(" INCLUDE NA OPTION "),
        _createElementVNode("div", _hoisted_73, [
          _createElementVNode("div", _hoisted_74, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input shadow-none me-8",
              type: "checkbox",
              role: "switch",
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.local_step.include_na_option) = $event)),
              id: "include_na_option",
              "true-value": 1,
              "false-value": 0
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, _ctx.local_step.include_na_option]
            ]),
            _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('feature.surveys.include_na_option')), 1 /* TEXT */)
          ])
        ]),
        _createCommentVNode(" CONDITIONS "),
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t('feature.surveys.conditions')), 1 /* TEXT */),
            _createElementVNode("code", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.local_step.conditions) = $event)),
                class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.conditions }]])
              }, null, 2 /* CLASS */), [
                [_vModelText, _ctx.local_step.conditions]
              ])
            ]),
            _createCommentVNode(" ERRORS "),
            (_ctx.errors?.conditions ?? false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.conditions, (error) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: error,
                      class: "small text-danger lh-1 m-0 mt-1"
                    }, _toDisplayString(error), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _hoisted_80,
        _createCommentVNode(" DISPLAY IN CHART "),
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("div", _hoisted_82, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input shadow-none me-8",
              type: "checkbox",
              role: "switch",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.local_step.display_in_chart) = $event)),
              id: "display_in_chart",
              "true-value": 1,
              "false-value": 0
            }, null, 512 /* NEED_PATCH */), [
              [_vModelCheckbox, _ctx.local_step.display_in_chart]
            ]),
            _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t('feature.surveys.display_in_chart')), 1 /* TEXT */)
          ])
        ]),
        (_ctx.local_step.display_in_chart)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.$t('feature.surveys.chart_type')) + "* ", 1 /* TEXT */),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("select", {
                      class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.chart_type }]]),
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.local_step.chart_type) = $event)),
                      required: _ctx.local_step.display_in_chart
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chart_types, (key) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: key,
                          key: key
                        }, _toDisplayString(_ctx.$t(`feature.surveys.$chart_type.${key}`)), 9 /* TEXT, PROPS */, _hoisted_88))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 10 /* CLASS, PROPS */, _hoisted_87), [
                      [_vModelSelect, _ctx.local_step.chart_type]
                    ]),
                    _createCommentVNode(" ERRORS "),
                    (_ctx.errors?.value_representation_type ?? false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.value_representation_type, (error) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: error,
                              class: "small text-danger lh-1 m-0 mt-1"
                            }, _toDisplayString(error), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ]),
              _hoisted_90
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}